import microuniversoApi from "app/api/microuniversoApi"
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse"
import { FiltroPesquisaClientes } from "app/types/cliente/FiltroPesquisaClientes"
import { tratamentoErroPadrao } from "app/use-cases"
import { Dict } from "app/utils/Dict"
import globalMU from "globalMU"
import * as R from "ramda"
import React, { useEffect, useRef, useState } from "react"
import { PesquisarClienteContainer } from "../pesquisa-cliente/PesquisarClienteContainer"
import { renderizarComponentReact } from "../renderizarOuRemoverComponentReact"
import { Parametro, ParametroPorItem } from "app/types/Parametro"
import { obterParametros, obterParametrosPorOidItem } from "app/use-cases/parametro/obterParametros"
import { IFilial } from "app/types/IFilial"
import { Vendedor } from "app/types/Vendedor"
import { ComissaoPorClassificacao } from "./ComissaoPorClassificacao"
import { ComissaoPorClassificacaoDadosParaFiltro, ComissaoPorClassificacaoResultado } from "app/types/Comissao-por-classificacao/ComissaoPorClassificacao"

declare const window: any;



export const ComissaoPorClassificacaoContainer = () => { // 482087

    const passosInterno = useRef<Dict<string, () => void>>(new Dict())
    const [parametrosPorFilial, setParametrosPorFilial] = useState<ParametroPorItem[]>([]) // 450413
    const [dadosParaFiltro, setDadosParaFiltro] = useState<ComissaoPorClassificacaoDadosParaFiltro>(null)
    const [vendedorLogado, setVendedorLogado] = useState<Vendedor>(null)
    const [processando, setProcessando] = useState<boolean>(false)
    const [comissoesPorClassificacao, setComissoesPorClassificacao] = useState<ComissaoPorClassificacaoResultado[]>([]) // 482087
    const [dadosCarregados, setDadosCarregados] = useState<boolean>(false)


    useEffect(() => {
        passosInterno.current.set("Consulta Comissao Por Classificacao", null)
        buscarDadosIniciais()
    }, [])

    const buscarDadosIniciais = async () => {
        const vendedorLogado = await microuniversoApi.Vendedor.ObterVendedorAutenticado()
        if (!vendedorLogado || vendedorLogado == null) {
            globalMU.showErrorMessage(`Favor fazer login do vendedor.`)
            return 
        }

        var parametros = obterParametros({
                nomes: [
                    "UTILIZA_CALCULO_COMISSAO_POR_CLASSIFICACAO_VENDEDOR_FAIXA_DESCONTO", // por filial
                ],
            })

        const parametrosFiliais = await obterParametrosPorOidItem(
            {
                nomes:
                [
                    "UTILIZA_CALCULO_COMISSAO_POR_CLASSIFICACAO_VENDEDOR_FAIXA_DESCONTO",
                ], oidItem: vendedorLogado.OidFilial
            })
        setParametrosPorFilial(parametrosFiliais)  
        const paramUtilizaCalculoComissaoPorClassificacaoVendedorFaixaDesconto = (parametrosFiliais.find((p) => p.Nome == "UTILIZA_CALCULO_COMISSAO_POR_CLASSIFICACAO_VENDEDOR_FAIXA_DESCONTO").Valor ?? "N" )
        if (paramUtilizaCalculoComissaoPorClassificacaoVendedorFaixaDesconto !== "S") {
            globalMU.showErrorMessage(`Consulta não disponível!<br/><br/>Veja parâmetro: Utiliza cálculo de comissão por classificação de vendedor e faixa de desconto`)
            return 
        }
        const dadosIniciais = await microuniversoApi.ComissaoPorClassificacao.ObterDadosParaFiltro()

        setDadosParaFiltro(dadosIniciais)
        setVendedorLogado(vendedorLogado)
        setProcessando(false)
        setDadosCarregados(true)
    }

    const pesquisar = async (codigoVendedor: string, codigoFilial: string, dataInicial: Date, dataFinal: Date) => {
        setProcessando(true)
        const codigoVendedorLogado = vendedorLogado?.Codigo
        const comissoes = await microuniversoApi.ComissaoPorClassificacao.Obter(codigoVendedorLogado, codigoFilial, codigoVendedor, dataInicial, dataFinal)
        setComissoesPorClassificacao(comissoes)

        if (comissoes && comissoes.length <= 0)
            globalMU.showErrorMessage("Nenhum resultado encontrado para os filtros selecionados.")
        setProcessando(false)
    }


return  (
    <>
        {dadosCarregados &&         
            <ComissaoPorClassificacao
                ListaFiliais={dadosParaFiltro?.ListaFiliais || []}
                ListaVendedores={dadosParaFiltro?.ListaVendedores || []}
                VendedorLogado={vendedorLogado}
                Resultado={comissoesPorClassificacao}
                Processando={processando}       
                onPesquisar={(codigoVendedor: string, codigoFilial: string, dataInicial: Date, dataFinal: Date) => pesquisar(codigoVendedor, codigoFilial, dataInicial, dataFinal)}
                
            />
        }
    </>
    )
}

window.ComissaoPorClassificacaoContainer = ComissaoPorClassificacaoContainer
